import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { IState } from './models/IState';
import accountReducer from './reducers/account.reducer';
import applicationReducer from './reducers/application.reducer';
import timesheetReducer from './reducers/timesheet.reducer';

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
    applicationState: applicationReducer,
    timesheetState: timesheetReducer,
    accountState: accountReducer
};

export default function configureStore(history?: History, initialState?: IState) {
    let middleware;
    let rootReducer: any;

    if (history) {
        middleware = [
            thunk,
            routerMiddleware(history)
        ];

        rootReducer = combineReducers({
            ...reducers,
            router: connectRouter(history)
        });
    }
    else {
        // Used for testing.
        rootReducer = combineReducers({
            ...reducers
        });

        middleware = [
            thunk
        ];
    }

    const enhancers = [];
    const windowIfDefined = typeof window === 'undefined' ? null : window as any; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION__());
    }

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}
